
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11012_456350)"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"5","fill":"#2C8DFF"}}),_c('rect',{attrs:{"x":"5","y":"10","width":"2","height":"5","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"9","y":"8","width":"2","height":"7","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"13","y":"5","width":"2","height":"10","rx":"1","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11012_456350"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    